import React, { useState, useEffect } from "react";
import Secondheader from "../components/SecondHeader/Secondheader";
import "./main.css";
import Meta from "../images/meta.png";
import Phone from "../images/phone.png";
import Mail from "../images/mail.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Header from '../components/header/Header';
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { KEY } from "../api";

const Conntact = () => {
  const [data, setData] = useState({});
  const [contactData, setContactData] = useState({
    title: "Let's talk with us",
    description: "Questions, comments, or suggestions? Simply fill in the form and we’ll be in touch shortly.",
    address: "1055 Arthur ave Elk Groot, 67. New Palmas South Carolina.",
    phone: "+1 234 678 9108 99",
    email: "Contact@moralizer.com",
  });
  const location = useLocation();

  // Fetch data from Strapi
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_STRAPI_API_URL}/api/contacts`);
        const result = await response.json();
        if (result.data && result.data.length > 0) {
          const { title, description, address, phone, email } = result.data[0];
          setContactData({ title, description, address, phone, email });
        }
      } catch (error) {
        console.error("Error fetching Strapi data:", error);
      }
    };

    fetchContactData();
  }, []);

  // Scroll to top on location change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [registrationSuccess, setRegistrationSuccess] = useState(false);

  const handleSubmit = async (data) => {
    try {
      const response = await KEY.post(
          "/contact/request",
          data,
          {
            headers: {
              "Accept-Language": "en",
              "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
          }
      );

      setRegistrationSuccess(true);
    } catch (error) {
      setRegistrationSuccess(false);
    }
  };

  return (
      <div className="uploadContent">
        <Header />
        <div className="privicy">
          <div className="container">
            <div className="contactUs">
              <div className="talkwithUs">
                <h1>{contactData.title}</h1>
                <p>{contactData.description}</p>
                <Link>
                  <img src={Meta} alt="image" />
                  {contactData.address}
                </Link>
                <Link>
                  <img src={Phone} alt="image" />
                  {contactData.phone}
                </Link>
                <Link>
                  <img src={Mail} alt="image" />
                  {contactData.email}
                </Link>
              </div>
              <div className="contactInputs">
                <Formik
                    initialValues={{
                      email: "",
                      name: "",
                      surname: "",
                      message: "",
                    }}
                    validate={(values) => {
                      const errors = {};
                      if (!values.email) {
                        errors.email = "Required";
                      } else if (
                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                              values.email
                          )
                      ) {
                        errors.email = "Invalid email address";
                      } else if (!values.name) {
                        errors.name = "Required";
                      } else if (!values.surname) {
                        errors.surname = "Required";
                      } else if (!values.message) {
                        errors.message = "Required";
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      setTimeout(() => {
                        handleSubmit(values);
                        setSubmitting(false);
                        resetForm();
                      }, 400);
                    }}
                >
                  {({ isSubmitting, errors, touched, setFieldValue }) => (
                      <div className="contactInfo">
                        <Form className="contactForm">
                          <label className="contactLabel">Name</label>
                          <Field
                              type="text"
                              name="name"
                              className="nameInput"
                              autoComplete="off"
                              placeholder="Enter your name"
                          />
                          {errors.name && touched.name ? (
                              <div className="error">{errors.name}</div>
                          ) : null}
                          <label className="contactLabel">Surname</label>
                          <Field
                              type="text"
                              name="surname"
                              className="nameInput"
                              autoComplete="off"
                              placeholder="Enter your surname"
                          />
                          {errors.surname && touched.surname ? (
                              <div className="error">{errors.surname}</div>
                          ) : null}
                          <label className="contactLabel">Email</label>
                          <Field
                              type="email"
                              name="email"
                              autoComplete="off"
                              className="nameInput"
                              placeholder="Enter your email"
                          />
                          {errors.email && touched.email ? (
                              <div className="error">{errors.email}</div>
                          ) : null}
                          <label className="contactLabel">Your Message</label>
                          <Field
                              component="textarea"
                              className="textareaInput"
                              name="message"
                              placeholder="Your Message..."
                              rows="4"
                          />
                          {errors.message && touched.message ? (
                              <div className="error">{errors.message}</div>
                          ) : null}
                          {registrationSuccess ? (
                              <p className="successChange">Your message has been sent.</p>
                          ) : null}
                          <div className="cancelSave">
                            <button type="submit" className="contactSave">
                              Send Message
                            </button>
                          </div>
                        </Form>
                      </div>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Conntact;